<template>
    <div>
        <vs-prompt :title="isNew ? 'Add priceGroup' : 'Update priceGroup'" @cancel="val = ''" @accept="accept"
            @close="close" :active.sync="prompt" :accept-text="isNew ? 'Add' : 'Update'" :is-valid="validForm" class="">
            <vs-row>
                <vs-col vs-w="12">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/5 w-full">
                            <span>Name</span>
                        </div>
                        <div class="vx-col sm:w-4/5 w-full">
                            <vs-input v-model="name" />
                        </div>

                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/5 w-full">
                            <span>Default price</span>
                        </div>
                        <div class="vx-col sm:w-4/5 w-full">
                            <vs-checkbox v-model="isDefault" />
                        </div>

                    </div>
                </vs-col>
            </vs-row>
        </vs-prompt>
    </div>
</template>
  
  
<script>
import { mapGetters } from "vuex";
export default {
    components: {},
    data() {
        return {
            existingId: null,
            name: "",
            isDefault: false,
            prompt: false,
        };
    },
    computed: {
        ...mapGetters({}),
        isNew() {
            return !this.existingId;
        },
        validForm() {
            return this.name && this.name.length > 0;
        },
    },
    methods: {
        show(withStorage) {
            this.name = "";
            this.isDefault = false;
            this.existingId = null;

            if (withStorage) {
                this.existingId = withStorage.priceGroupId.id;
                this.name = withStorage.name;
                this.isDefault = withStorage.isDefault;
            }
            this.prompt = true;
        },
        async accept() {
            const dto = {
                name: this.name,
                isDefault: this.isDefault
            };

            if (this.isNew) {
                dto.id = this.uuidv4();
                this.$store.commit("pos/countrySettings/createPriceGroup", dto);
            } else {
                dto.id = this.existingId;
                this.$store.commit("pos/countrySettings/updatePriceGroup", dto);
            }
        },
        uuidv4() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
                (
                    c ^
                    (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
                ).toString(16)
            );
        },
        close() { },
    },
};
</script>
  
<style lang="scss" scoped></style>
  